import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { VerizonReport } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<unknown, Error, { id: number }, VerizonReport>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useDeleteVerizonReportRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, { id: number }, VerizonReport>(
    [Entities.VerizonReports, 'delete'],
    async ({ id }) => {
      const { data } = await api.v1AdminVerizonReportsIdDelete(id)
      return data
    },
    { ...options },
  )
}
